import { Box, IconButton, Stack } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";

import FemaleAvatar from "../../icons/FemaleAvatar";
import { useUserStore } from "../../stores/userStore";
import Text from "../atoms/Text";
import LogoutIcon from "../icons/ui-actions/LogoutIcon";

const ProfileStack = () => {
  const [userState, clearUserState] = useUserStore(state => [
    state.user,
    state.clearUser,
  ]);
  const { authState, oktaAuth } = useOktaAuth();

  const logout = async () => {
    await oktaAuth.signOut();
    clearUserState();
  };

  if (!authState) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center">
      <Stack direction="row" spacing={1} ml="5px" mr={1.5}>        
          <Box sx={{display:"flex", alignItems:"center", width:"100%"}}>
        <Text variant="body_small">{userState?.name}</Text>
        </Box>
        {/* {userState?.isApprover && (
          <Label variant="body_small" label="Approver" />
        )} */}
        <FemaleAvatar/>
      </Stack>
      <IconButton size="small" edge="start" onClick={logout}>
        <LogoutIcon width={24} height={24} />
      </IconButton>
    </Stack>
  );
};

export default ProfileStack;
